/**
 * Button constants for MsButton component
 */

/**
 * Button types
 * @type {Object}
 */
export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary', 
  OUTLINE_BUTTON: 'outline-button',
  SECONDARY_OUTLINE: 'secondary-outline'
}

/**
 * Valid button types array
 * @type {string[]}
 */
export const VALID_BUTTON_TYPES = Object.values(BUTTON_TYPES)

/**
 * Icon sizes
 * @type {Object}
 */
export const ICON_SIZES = {
  SMALL: 'icon16',
  LARGE: 'icon24'
}

/**
 * Button CSS classes
 * @type {Object}
 */
export const BUTTON_CLASSES = {
  BASE: 'ms-button btn',
  ONLY_ICON: 'only-icon',
  RADIUS: 'btn-radius',
  NO_BORDER: 'btn-border-none',
  DISABLED: 'disabled-icon'
}

/**
 * Default props values
 * @type {Object}
 */
export const DEFAULT_PROPS = {
  type: BUTTON_TYPES.PRIMARY,
  isLagerIcon: true,
  disabled: false,
  processing: false,
  radius: false,
  hasBorder: false,
  shortkeyTarget: null
}

/**
 * Events emitted by the button
 * @type {string[]}
 */
export const BUTTON_EVENTS = [
  'click',
  'keydown', 
  'focus',
  'mousedown'
]
